import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import './ProjectPage.css';

// Import images
import webHeroImage from '../../assets/images/web.jpg';

const CorporateWeb = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Kurumsal Web Çözümleri | Profesyonel Web Sitesi ve E-Ticaret - ProgenX 2026</title>
        <meta name="description" content="ProgenX kurumsal web çözümleri. Modern ve etkileyici web siteleri, e-ticaret sistemleri, dijital pazarlama desteği. İşletmenizin dijital yüzü olun. SEO uyumlu, hızlı ve güvenilir web çözümleri." />
        <meta name="keywords" content="kurumsal web sitesi, e-ticaret çözümleri, dijital pazarlama, web tasarım, kurumsal kimlik, seo uyumlu web sitesi, responsive web tasarım, türkiye web tasarım şirketi" />
        <meta property="og:title" content="Kurumsal Web Çözümleri | ProgenX" />
        <meta property="og:description" content="Profesyonel web siteleri ve e-ticaret çözümleri ile dijital dünyada güçlü bir varlık oluşturun." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/projeler/kurumsal-web-cozumleri" />
        <link rel="canonical" href="https://progenx.com.tr/projeler/kurumsal-web-cozumleri" />
      </Helmet>

      <Hero 
        title="Kurumsal Web Çözümleri" 
        backgroundImage={webHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>İşletmenizin Dijital Yüzü</h2>
            <p>
              Web siteniz, işletmenizin dijital dünyadaki yüzüdür. Müşterileriniz sizi ilk 
              orada görür, ilk izlenimi orada oluşturur. ProgenX olarak, işletmenizin kurumsal 
              kimliğini en iyi şekilde yansıtan, müşterilerinizi etkileyen ve onlara kolay 
              erişim sağlayan web siteleri geliştiriyoruz.
            </p>
          </section>

          <section className="project-features">
            <h3>Ne Tür Web Çözümleri Sunuyoruz?</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>Kurumsal Web Siteleri</h4>
                <p>
                  İşletmenizin hikayesini anlatan, ürün ve hizmetlerinizi sergileyen profesyonel 
                  web siteleri. Telefon, tablet, bilgisayar - her cihazda mükemmel görünür. 
                  Google'da üst sıralarda çıkar, içeriklerinizi kolayca güncelleyebilirsiniz.
                </p>
              </div>

              <div className="feature-item">
                <h4>E-Ticaret Siteleri</h4>
                <p>
                  Ürünlerinizi online satmanızı sağlayan e-ticaret siteleri. Güvenli ödeme 
                  sistemleri, stok takibi, sipariş yönetimi - her şey tek bir yerde. 
                  Müşterileriniz kolayca alışveriş yapar, siz kolayca yönetirsiniz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Dijital Pazarlama Desteği</h4>
                <p>
                  Web siteniz hazır olduktan sonra müşterilerinize ulaşmanıza yardımcı oluyoruz. 
                  Google'da üst sıralarda çıkmanızı sağlıyor, sosyal medyada görünürlüğünüzü 
                  artırıyor, müşteri kazanmanıza destek oluyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>İşletmenize Özel Çözümler</h4>
                <p>
                  Mevcut sistemlerinizle entegre çalışan, işletmenizin özel ihtiyaçlarına göre 
                  geliştirilmiş çözümler. Müşteri yönetim sistemleriniz, stok takip sistemleriniz 
                  - hepsi web sitenizle uyumlu çalışır.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>İşletmeniz İçin Ne Sağlıyoruz?</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Profesyonel ve Etkileyici Görünüm</h4>
                <p>Web siteniz işletmenizin kurumsal kimliğini yansıtır, müşterilerinizi 
                etkiler. Modern ve şık tasarımlarla markanızı güçlendirir.</p>
              </div>
              <div className="benefit-item">
                <h4>Hızlı ve Güvenilir</h4>
                <p>Web siteniz hızlı yüklenir, güvenli çalışır. Müşterileriniz kolayca 
                erişir, bilgileri güvenle paylaşır.</p>
              </div>
              <div className="benefit-item">
                <h4>Daha Fazla Müşteri</h4>
                <p>Google'da üst sıralarda çıkar, sosyal medyada görünür olursunuz. 
                Daha fazla müşteri web sitenizi ziyaret eder, sizinle iletişime geçer.</p>
              </div>
              <div className="benefit-item">
                <h4>Her Zaman Güncel</h4>
                <p>Web sitenizi kolayca güncelleyebilir, içeriklerinizi yönetebilirsiniz. 
                İhtiyaçlarınız değiştikçe web siteniz de gelişir.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Dijital Dünyada Güçlü Bir Varlık Olun"
        subtitle="Profesyonel web sitenizle müşterilerinize ulaşın ve işletmenizi büyütün."
        buttonText="Teklif Alın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default CorporateWeb; 